import {combineReducers} from '@modifi/redux'
import transactionReducer from './transaction/reducer'

export default combineReducers({
  transaction: transactionReducer,
})
